import { useEffect, useState } from 'react'
import { api, ROUTES } from './api'
import { useAdmin, useAsync, Field, ErrorState, Loading, PageHead } from './ui'

const FIELDS = [
  { key: 'announcement_text', label: 'Announcement bar', hint: 'Short message shown above the header, e.g. "Free delivery above Rs 999".' },
  { key: 'free_shipping_note', label: 'Delivery note', hint: 'Shown near the cart and checkout totals.' },
  { key: 'contact_phone', label: 'Contact phone' },
  { key: 'contact_email', label: 'Contact email' },
  { key: 'footer_text', label: 'Footer text', multiline: true },
]

export default function SiteText() {
  const { toast } = useAdmin()
  const { data, loading, error, reload } = useAsync(() => api.get(ROUTES.settings))
  const [v, setV] = useState({})
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (data) setV(data)
  }, [data])

  const save = async (e) => {
    e.preventDefault()
    setSaving(true)
    try {
      await api.put(ROUTES.adminSettings, v)
      toast('Site text saved')
    } catch (err) {
      toast(err.message, 'err')
    }
    setSaving(false)
  }

  if (error) return <ErrorState error={error} endpoint={`GET ${ROUTES.settings}`} onRetry={reload} />
  if (loading) return <Loading />

  return (
    <>
      <PageHead title="Site text" sub="Messages and contact details used across your storefront." />
      <form className="panel form-stack" onSubmit={save}>
        <label className="check">
          <input type="checkbox" checked={v.announcement_active === '1' || v.announcement_active === 1 || v.announcement_active === true} onChange={(e) => setV({ ...v, announcement_active: e.target.checked ? '1' : '0' })} />
          Show the announcement bar
        </label>
        {FIELDS.map((f) => (
          <Field key={f.key} label={f.label} hint={f.hint}>
            {f.multiline ? (
              <textarea className="input" rows="3" value={v[f.key] ?? ''} onChange={(e) => setV({ ...v, [f.key]: e.target.value })} />
            ) : (
              <input className="input" value={v[f.key] ?? ''} onChange={(e) => setV({ ...v, [f.key]: e.target.value })} />
            )}
          </Field>
        ))}
        <div><button className="btn primary" disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button></div>
      </form>
    </>
  )
}
